import { useCallback, useEffect, useRef, useState } from 'react';
import { mailApi, type TicketMailInfo } from '@/shared/api';

export function useTicketMail(ticketId: string | null | undefined, enabled: boolean) {
  const [info, setInfo] = useState<TicketMailInfo | null>(null);
  const seq = useRef(0);

  const refresh = useCallback(async () => {
    if (!ticketId || !enabled) return;
    const mine = ++seq.current;
    try {
      const res = await mailApi.ticketMail(ticketId);
      if (mine === seq.current) setInfo(res.data);
    } catch {
      if (mine === seq.current) setInfo(null);
    }
  }, [ticketId, enabled]);

  useEffect(() => {
    setInfo(null);
    void refresh();
  }, [refresh]);

  const refreshSoon = useCallback(() => {
    void refresh();
    window.setTimeout(() => void refresh(), 4000);
  }, [refresh]);

  return { info, refresh, refreshSoon };
}
